import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import "./file-progress.scss";
import { TransactionTypeEnum } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
var FileProgress = function (_a) {
    var _b, _c;
    var fileName = _a.fileName, progress = _a.progress, size = _a.size, imagePreview = _a.imagePreview, onClickClose = _a.onClickClose, onClickPreview = _a.onClickPreview, failure = _a.failure, activePreview = _a.activePreview;
    var pdfContentType = "application/pdf";
    var previewRef = useRef(null);
    var isPdf = (_b = fileName === null || fileName === void 0 ? void 0 : fileName.toLowerCase()) === null || _b === void 0 ? void 0 : _b.endsWith(".pdf");
    /**
     * Converts base64 string (with or without data URL prefix) to a Blob
     * @param base64Data - Base64 encoded string
     * @returns Blob
     */
    var base64toBlob = function (base64Data) {
        try {
            // If the base64 string contains a prefix like "data:application/pdf;base64,", strip it
            var base64 = base64Data.includes("base64,")
                ? base64Data.split("base64,")[1]
                : base64Data;
            var binary = atob(base64); // decode base64 to binary string
            var len = binary.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            return new Blob([bytes], { type: pdfContentType });
        }
        catch (error) {
            console.error("Failed to convert base64 to blob:", error);
            return new Blob(); // return empty blob if error occurs
        }
    };
    var url = isPdf && imagePreview
        ? URL.createObjectURL(base64toBlob(imagePreview))
        : "";
    var activeTypeList = useSelector(function (state) { return state.markets.global; }).activeTypeList;
    var handleClose = function () {
        if (onClickClose) {
            onClickClose();
        }
    };
    var extension = (_c = fileName === null || fileName === void 0 ? void 0 : fileName.split(".").pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    var getIcon = function () {
        switch (extension) {
            case "pdf":
                return (React.createElement(Edelicon, { className: "edel-icon-pdf1 d-flex justify-content-center align-items-center", paths: 14 }));
            case "png":
                return (React.createElement(Edelicon, { className: "edel-icon-png d-flex justify-content-center align-items-center", paths: 66 }));
            case "jpeg":
                return (React.createElement(Edelicon, { className: "edel-icon-jpeg d-flex justify-content-center align-items-center", paths: 13 }));
            case "jpg":
                return (React.createElement(Edelicon, { className: "edel-icon-jpg d-flex justify-content-center align-items-center", paths: 12 }));
            default:
                return null;
        }
    };
    useEffect(function () {
        if (activePreview === fileName && previewRef.current) {
            previewRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [activePreview, fileName]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "file-progress-container" },
            React.createElement("div", { className: "file-progress" },
                React.createElement("div", { className: "file-progress__icon" }, getIcon()),
                React.createElement("div", { className: "file-progress__details" },
                    React.createElement("div", { className: "main-header" },
                        React.createElement("div", { className: "" },
                            React.createElement("div", { className: "file-progress__header" },
                                React.createElement("p", { className: "file-progress__name DMSanN_14_400 text-truncate" }, fileName),
                                !failure && progress > 99 && (React.createElement("p", { className: "file-progress__preview DMsanR_10_400", style: { cursor: "pointer" }, onClick: function () {
                                        onClickPreview();
                                    } },
                                    "(",
                                    React.createElement("u", null, "Preview"),
                                    ")"))),
                            React.createElement("div", { className: "file-progress__status" },
                                React.createElement("span", { className: "file-progress__size DMsanR_10_400" }, size),
                                React.createElement("span", { className: "crical" }),
                                React.createElement("span", { className: "file-progress__progress-text DMsanR_10_400" },
                                    !failure && "".concat(progress, "%").concat(" "),
                                    (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.Redeem ||
                                        (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) ==
                                            TransactionTypeEnum.TransferIn ? (React.createElement("span", { className: "".concat("green-text", " ") }, "Completed")) : (React.createElement("span", { className: "".concat(progress == 100 && !failure && "green-text", " ").concat(failure && "txt_tomatoRed") }, !failure ? "Completed" : "Failed"))))),
                        React.createElement("div", { className: "file-progress__close", onClick: handleClose }, (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.Redeem ||
                            (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.TransferIn ? (React.createElement("i", { className: "edel-icon-trash" })) : progress < 100 ? (failure ? (React.createElement("i", { className: "edel-icon-double-refresh d-flex justify-content-center align-items-center text-han-blue" })) : (React.createElement("i", { className: "edel-icon-close d-flex justify-content-center align-items-center text-han-blue" }))) : (React.createElement("i", { className: "edel-icon-delete-red1" })))),
                    progress < 100 && (React.createElement("div", { className: "file-progress__bar" },
                        React.createElement("div", { className: "file-progress__bar-inner ".concat(!failure
                                ? "file-progress__bar-inner"
                                : "file-progress__bar-inner-failed"), style: { width: "".concat(Number(progress), "%") } }))))),
            imagePreview && activePreview === fileName && (React.createElement("div", { className: "image-preview d-flex flex-column align-items-center", ref: previewRef },
                React.createElement("div", { className: "file-preview_close_container mb-1 w-100", style: {}, onClick: function () { return onClickPreview(); } },
                    React.createElement("div", null),
                    React.createElement("i", { className: "edel-icon-close d-flex justify-content-center align-items-center text-han-blue file-preview__close" })),
                isPdf ? (React.createElement("div", { className: "pdf-preview" },
                    React.createElement("iframe", { src: url !== null && url !== void 0 ? url : "", width: "100%", height: "500px", frameBorder: "0", title: "PDF Preview", loading: "lazy" }))) : (React.createElement("div", { className: "image-preview d-flex flex-column align-items-center" },
                    React.createElement("img", { src: imagePreview, alt: "Preview", style: {
                            width: "138px",
                            height: "194px",
                            objectFit: "contain",
                        } }))))))));
};
export default FileProgress;
